import styled from 'styled-components';

export const ContainerListUser = styled.div``;